import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import shortID from 'short-id-gen';
import { InputGroup, ProgressBar, Intent } from '@blueprintjs/core';
import { Row, Column as Col } from 'hedron';
import Modal from './Modal';
import TopToaster from '../toaster';

const initialState = {
  droppedImage: null,
  name: null,
  description: null,
  uploadProgress: 0,
  fileExtension: null,
};

class ImageModal extends Modal {

  constructor(props) {
    super(props);

    this.state = initialState;

    this.onDrop = this.onDrop.bind(this);

    this.iconName = "media";
    this.title = "Neue Datei";
    this.saveButtonIcon = 'upload';
    this.initialState = initialState;
  }

  hide() {
    this.setState({
      droppedImage: null,
      name: null,
      description: null,
      uploadProgress: 0,
    });
    this.props.hide();
  }

  onDrop(images) {
    if (images && images[0] && images[0].name) {
      this.setState({
        droppedImage: images[0],
        fileExtension: images[0].name.split('.').pop(),
        name: (!this.state.name || this.state.name === '') ? images[0].name : this.state.name,
      });
    }
  }

  save() {
    console.log('upload pressed');
    if (!this.state.droppedImage || !this.state.name || !this.state.fileExtension) {
      return;
    }

    const imageID = shortID.generate(10);
    const filename = `${imageID}.${this.state.fileExtension}`;
    const upload = this.props.customerStorageRef.child('images').child(filename).put(this.state.droppedImage);
    const saveState = this.state;
    const saveProps = this.props;

    const toastID = TopToaster.show({
      timeout: 0,
      iconName: 'cloud-upload',
      onDismiss: ()=>upload.cancel(),
      message: (
        <ProgressBar
          value={0}
        />
      ),
    });
    upload.on('state_changed', (snap) => {
      TopToaster.update(toastID, {
        timeout: 0,
        iconName: 'cloud-upload',
        onDismiss: ()=>upload.cancel(),
        message: (
          <ProgressBar
            value={(snap.bytesTransferred / snap.totalBytes)}
          />
        ),
      });
    }, (err) => {
      console.log(err);
    }, () => {
      console.log('Uploaded');
      saveProps.customerStorageRef.child('images').child(filename).getDownloadURL()
      .then((url) => {
        saveProps.database.ref(`images/${imageID}`).set({
          customer: saveProps.customerID,
          name: saveState.name,
          description: saveState.description,
          createdAt: new Date(),
          lastModified: new Date(),
          url,
          filename,
        })
        .then(() => {
          TopToaster.update(toastID, {
            timeout: 0,
            iconName: 'cloud-upload',
            message: 'Image saved',
            intent: Intent.SUCCESS,
          });
        })
        .catch(err => {
          console.log(err)
          TopToaster.update(toastID, {
            timeout: 0,
            intent: Intent.DANGER,
            iconName: 'cloud-upload',
            message: 'Bild könnte nicht hochgeladen werden.',
          });
        });
      })
      .catch(err => {
        console.log(err);
        TopToaster.update(toastID, {
          timeout: 0,
          intent: Intent.DANGER,
          iconName: 'cloud-upload',
          message: 'Bild könnte nicht hochgeladen werden.',
        });
      });
    });

    this.hide();
  }

  renderBody() {
    return (
      <Row>
        <Col sm={12}>
          <Dropzone onDrop={this.onDrop} multiple={false} disablePreview={true}>
            <div>
              {this.state.droppedImage ? this.state.droppedImage.name : 'Bild-Datei hierher bewegen'}
            </div>
          </Dropzone>
        </Col>
        <Col sm={6}>
          <label>
            Name
            <InputGroup
              type="text"
              value={this.state.name || ''}
              placeholder={this.state.name ? null : 'Name der Datei'}
              onChange={(e) => this.setState({ name: e.target.value })}
            />
          </label>
        </Col>
        <Col sm={6}>
          <label>
            Beschreibung
            <InputGroup
              type="text"
              value={this.state.description || ''}
              placeholder="Beschreibung der Datei"
              onChange={(e) => this.setState({ description: e.target.value })}
            />
          </label>
        </Col>
      </Row>
    );
  }
}

export default ImageModal;



/** WEBPACK FOOTER **
 ** ./src/modals/ImageModal.js
 **/